import icon from "@pag/center/components/icon/icons"
import { IconType } from "@pag/center/components/icon/types"

const hourLength = 3600

export enum FormattedDurationEnum {
  default = "",
  positive = "+",
  negative = "-"
}

function socIconColor(soc: number | undefined): string | undefined {
  if (soc !== undefined) {
    if (soc <= 7) {
      return "charge-low"
    }
    if (soc < 20) {
      return "charge-medium"
    }
  }
}

function socIconType(soc: number | undefined): IconType {
  if (soc === undefined || soc <= 0) {
    return icon.soc_destination_flag_blank_white_C8_2
  }
  if (soc <= 7) {
    return icon.soc_destination_flag_0_white_C8_2
  }
  if (soc < 20) {
    return icon.soc_destination_flag_1_white_C8_2
  }
  if (soc < 40) {
    return icon.soc_destination_flag_2_white_C8_2
  }
  if (soc < 60) {
    return icon.soc_destination_flag_3_white_C8_2
  }
  if (soc < 80) {
    return icon.soc_destination_flag_4_white_C8_2
  }
  return icon.soc_destination_flag_5_white_C8_2
}

function range(target: number, min: number, max: number, out_min: number, out_max: number) {
  var t_val = ((target - min) * (out_max - out_min)) / (max - min) + out_min
  if (t_val > Math.max(out_max, out_min)) {
    t_val = Math.max(out_max, out_min)
  }
  if (t_val < Math.min(out_max, out_min)) {
    t_val = Math.min(out_max, out_min)
  }
  return t_val
}

function formattedDuration(number: number = 0, numberConfiguration: FormattedDurationEnum = FormattedDurationEnum.default) {
  if (number < hourLength) {
    const minutes = String(Math.trunc(number / 60))
    return numberConfiguration + minutes + " min"
  }

  const hours = String(Math.trunc(number / hourLength))
  const minutes = String(Math.trunc((number % hourLength) / 60))

  return numberConfiguration + hours + ":" + minutes.padStart(2, "0") + " h"
}

export { socIconColor, socIconType, range, formattedDuration }
